import script from "./DeclarationBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./DeclarationBlock.vue?vue&type=script&setup=true&lang=js"

import "./DeclarationBlock.vue?vue&type=style&index=0&id=c55a5820&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c55a5820"]])

export default __exports__